<div class="cgv-container">
  <h1>Conditions Générales d’Utilisation – Service Qaryos</h1>
  <p class="last-updated">Dernière mise à jour : 20 mai 2025</p>

  <nav class="cgv-toc">
    <h2>Sommaire</h2>
    <ul>
      <li>1. Préambule</li>
      <li>2. Accès au Service – Comptes et Rôles des Utilisateurs</li>
      <li>3. Utilisation autorisée et interdite du Service</li>
      <li>4. Sécurité des accès et protection des données</li>
      <li>5. Limitation de responsabilité</li>
      <li>6. Propriété intellectuelle</li>
      <li>7. Modification, suspension et cessation du Service</li>
      <li>8. Droit applicable et juridiction compétente</li>
      <li>9. Évolution des CGU</li>
    </ul>
  </nav>

  <section id="preambule">
    <h2>1. Préambule</h2>
    <p>
      Qaryos est un service numérique destiné aux établissements professionnels (notamment hôtels,
      campings et autres ERP) pour digitaliser l’organisation de leurs rondes de sécurité. Il se
      compose d’un site internet (vitrine et interface web administrateur) et d’une application
      mobile pour les agents de sécurité (rondiers). L’objectif est de faciliter la planification,
      le suivi et la traçabilité des tournées de surveillance en temps réel.<br />
      Les présentes Conditions Générales d’Utilisation (« CGU ») définissent les modalités d’accès
      et d’utilisation du service Qaryos. Toute utilisation implique l’acceptation sans réserve de
      ces CGU. En cas de refus, l’utilisateur doit s’abstenir d’utiliser le service.
    </p>
  </section>

  <section id="acces-comptes">
    <h2>2. Accès au Service – Comptes et Rôles des Utilisateurs</h2>
    <p>L’accès complet à Qaryos nécessite la création d’un compte utilisateur :</p>
    <ul>
      <li>
        <b>Compte Administrateur :</b> réservé au représentant de l’établissement (ex : responsable
        sécurité). Permet de configurer le service, gérer les utilisateurs rondiers, consulter les
        rapports.
      </li>
      <li>
        <b>Compte Rondier :</b> destiné aux agents effectuant les rondes via l’application mobile,
        avec des identifiants fournis par l’administrateur.
      </li>
    </ul>
    <p>
      Chaque utilisateur doit fournir des informations exactes et à jour. Les comptes sont
      strictement personnels : il est interdit de partager ses accès, même temporairement. Toute
      utilisation non autorisée d’un compte engage la responsabilité de l’établissement client.<br />
      En cas de perte ou d’usage frauduleux des identifiants, l’utilisateur doit immédiatement
      prévenir Qaryos pour sécuriser le compte.<br />
      L’administrateur reste responsable de la gestion des accès de ses employés et doit
      supprimer/suspendre les accès en cas de départ. L’établissement assume la responsabilité de
      l’usage du service par ses employés, même en cas de manquement à ces CGU.
    </p>
  </section>

  <section id="utilisation">
    <h2>3. Utilisation autorisée et interdite du Service</h2>
    <p>
      <b>Obligations :</b> Les utilisateurs doivent utiliser Qaryos conformément à sa finalité
      professionnelle, dans le respect des lois, de l’ordre public et des droits des tiers.<br />
      Les informations et rapports fournis doivent être exacts, à jour et strictement
      professionnels.
    </p>
    <p>
      <b>Utilisations interdites :</b>
    </p>
    <ul>
      <li>Accès non autorisé ou contournement des mesures de sécurité (robots, scripts, etc.).</li>
      <li>Perturbation ou tentative de déstabilisation du service (surcharge, attaques, etc.).</li>
      <li>
        Extraction/réutilisation non autorisée des données, copie ou exploitation de contenus sans
        autorisation.
      </li>
      <li>
        Introduction de virus, codes malveillants, ou diffusion de contenus illicites, haineux, ou
        portant atteinte aux droits de tiers.
      </li>
    </ul>
    <p>
      Tout manquement pourra entraîner suspension ou suppression du compte, blocage de l’accès,
      voire poursuites judiciaires.
    </p>
  </section>

  <section id="securite-donnees">
    <h2>4. Sécurité des accès et protection des données</h2>
    <p>
      Qaryos met en œuvre des mesures de sécurité conformes aux standards de l’industrie
      (chiffrement, stockage sécurisé, etc.), mais ne garantit pas une sécurité absolue.<br />
      Chaque utilisateur doit contribuer à la sécurité (mot de passe robuste, équipements protégés,
      mises à jour, etc.).<br />
      En cas de suspicion d’accès non autorisé ou de faille de sécurité, il faut avertir Qaryos
      immédiatement.
    </p>
    <p>
      <b>Protection des données personnelles :</b> Les données personnelles sont traitées
      conformément au RGPD et à la loi française. Elles ne servent qu’au fonctionnement du service
      et ne sont communiquées à aucun tiers sans autorisation, sauf sous-traitants techniques
      sécurisés.<br />
      L’utilisateur dispose de droits d’accès, rectification, effacement, opposition, limitation et
      portabilité sur ses données, conformément à la politique de confidentialité.<br />
      En cas de violation de données, Qaryos notifiera les autorités et les utilisateurs concernés
      selon la loi.
    </p>
  </section>

  <section id="responsabilite">
    <h2>5. Limitation de responsabilité</h2>
    <p>
      Qaryos s’engage à fournir le service conformément aux CGU. Sa responsabilité est limitée aux
      seuls dommages directs, à l’exclusion de tous dommages indirects (perte de CA, perte de
      données, atteinte à la réputation, etc.).<br />
      Qaryos ne peut être tenu responsable :
    </p>
    <ul>
      <li>
        Des conséquences d’une faute ou négligence de l’utilisateur, ou d’une utilisation non
        conforme.
      </li>
      <li>
        De l’indisponibilité ou de dysfonctionnements (maintenance, mises à jour, incidents, etc.).
      </li>
      <li>Des évolutions techniques ou suspensions pour maintenance ou urgence.</li>
      <li>
        Des cas de force majeure ou faits hors du contrôle de Qaryos (sinistre, cyberattaque, panne
        générale, etc.).
      </li>
      <li>Des risques inhérents à Internet (virus, piratage, interception de données, etc.).</li>
      <li>
        Des données et contenus fournis par les utilisateurs (données erronées ou incomplètes).
      </li>
      <li>De l’utilisation de services tiers (hébergeur cloud, email, etc.).</li>
    </ul>
    <p>
      L’utilisateur reste responsable de l’usage qu’il fait du service et des résultats
      opérationnels qu’il en tire.<br />
      Si un préjudice est constaté, il doit être signalé à Qaryos dans les meilleurs délais pour
      analyse.
    </p>
  </section>

  <section id="propriete">
    <h2>6. Propriété intellectuelle</h2>
    <p>
      Le service Qaryos (site web, appli mobile, logiciels, interface, bases de données, contenus,
      logo, marque, etc.) est la propriété exclusive de la société éditrice.<br />
      Toute reproduction, imitation ou exploitation de la marque, du logo, du logiciel ou du contenu
      sans autorisation écrite est strictement interdite et pourra faire l’objet de poursuites.<br />
      L’utilisateur dispose seulement d’un droit d’usage personnel, non exclusif et non transférable
      du service pour ses besoins professionnels internes, pendant la durée de son abonnement.<br />
      L’utilisateur s’engage à respecter tous les droits de propriété intellectuelle de Qaryos et
      des tiers.
    </p>
  </section>

  <section id="modification-service">
    <h2>7. Modification, suspension et cessation du Service</h2>
    <p>
      Qaryos peut faire évoluer, suspendre ou cesser tout ou partie du service à tout moment (ajout,
      retrait, modification de fonctionnalités, arrêt du service, etc.).<br />
      Les opérations de maintenance sont planifiées pour limiter la gêne, mais des interruptions
      peuvent intervenir sans préavis en cas d’urgence.<br />
      En cas d’arrêt définitif, les utilisateurs seront informés autant que possible pour récupérer
      leurs données.<br />
      En cas de manquement grave à ces CGU, Qaryos pourra suspendre ou résilier le compte sans
      préjudice des droits ou obligations nés antérieurement.
    </p>
  </section>

  <section id="droit">
    <h2>8. Droit applicable et juridiction compétente</h2>
    <p>
      Les CGU et les relations entre l’utilisateur et la société éditrice de Qaryos sont régies par
      le droit français.<br />
      En cas de litige, les parties s’efforceront de trouver une solution amiable. À défaut,
      compétence exclusive est attribuée au Tribunal de Commerce du siège social de la société, sauf
      disposition légale impérative contraire.<br />
      L’utilisateur reconnaît avoir pris connaissance et accepté ces CGU, disponibles à tout moment
      sur le site.
    </p>
  </section>

  <section id="evolution">
    <h2>9. Évolution des CGU</h2>
    <p>
      Qaryos se réserve le droit de modifier à tout moment les présentes CGU, notamment pour suivre
      les évolutions légales, techniques ou fonctionnelles du service.<br />
      Toute nouvelle version entre en vigueur dès sa publication sur le site et l’application et
      prévaut sur toute version antérieure.<br />
      L’utilisateur est réputé avoir accepté la dernière version applicable à chaque connexion ou
      utilisation, et il est invité à consulter régulièrement la page dédiée.
    </p>
  </section>
</div>
